import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { COPYRIGHTS } from 'app/helpers/constants';
import { UserComponent } from 'app/layout/common/user/user.component';
import { AccountService } from 'app/services/account.service';
import { ChangeMyPasswordStore } from 'app/store/change-my-password.store';
import { AuthChangePasswordComponent } from 'pl-shared-lib';

@Component({
    selector: 'app-change-password',
    imports: [AuthChangePasswordComponent, UserComponent],
    templateUrl: './change-password.component.html',
    styleUrl: './change-password.component.scss',
})
export class ChangePasswordComponent implements OnInit {
    store = inject(ChangeMyPasswordStore);
    accountService = inject(AccountService);

    copyrights = COPYRIGHTS;
    returnUrl: string | null = null;

    constructor(
        private _router: Router,
        private _route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        const urlParam = this._route.snapshot.queryParamMap.get('returnUrl');
        if (urlParam) {
            this.returnUrl = urlParam;
        }
    }

    onCancel(): void {
        if (this.returnUrl) {
            this._router.navigate([this.returnUrl]);
        }
    }

    onSave(): void {
        this.store.changePassword();
    }
}
